import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router-dom";
import { Container, Center, Spinner } from "@chakra-ui/react";
import {
  getTemplates,
  createTemplate,
  getTemplate,
} from "../../redux/actions/templateActions";
import Header from "./Header";
import TemplateList from "./TemplateList";
import CustomModal from "./Modal";
import ModalFormPreview from "../Common/ModalFormPreview";
import { getTemplate as getPreviewTemplate } from "../../api/shortcodeTemplateApi";
import FormPreview from "../FormPreview";
import { defaultTemplates } from "./defaultTemplates.json";
const ChooseTemplatePage = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [previewMode, setPreviewMode] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);
  const [previewTemplateId, setPreviewTemplateId] = useState(null);
  const handleOnClose = (e, onClose) => {
    setShowModal((isToggled) => !isToggled);
    onClose();
  };
  const handlePreviewModeClose = (onClose) => {
    setPreviewMode((isToggled) => !isToggled);
    setPreviewTemplate(() => null);
    onClose();
  };
  const onClickUseTemplateHandler = (e, id) => {
    e.preventDefault();
    if (id == "blank_template") {
      return setShowModal((isToggled) => !isToggled);
    }
    if (id.includes("default")) {
      return props.dispatchGetTemplate(id, "default");
    }
    props.dispatchGetTemplate(id);
  };
  const onClickPreviewHandler = (e, id) => {
    e.preventDefault();
    setPreviewMode(true);
    setPreviewTemplateId(id);
  };

  const handleFormSubmit = (e, formTitle) => {
    e.preventDefault();
    const id = uuidv4();
    const description = "Build your form from scratch.";
    const imageUrl =
      "https://uxdt.nic.in/wp-content/uploads/2020/08/login_form_5_p.png";
    const templateType = "custom";
    const template = {
      id,
      title: formTitle,
      imageUrl,
      description,
      templateType,
    };
    props.dispatchCreateTemplate(template);
  };
  // useEffect(() => {
  // 	props.dispatchGetTemplates();
  // }, []);
  useEffect(() => {
    const apiUrl = `http://localhost/wordpress/wp-json`;
    const nonce = `5c74968270`;
    if (previewMode) {
      getPreviewTemplate(previewTemplateId, window.appLocalizer) //{ apiUrl, nonce } window.appLocalizer
        .then((template) => {
          console.log(template);
          setPreviewTemplate(() => ({ ...template }));
        })
        .catch((err) => {
          if (previewTemplateId.includes("default")) {
            const template = defaultTemplates.find(
              (template) => previewTemplateId == template.id
            );
            setPreviewTemplate(() => ({ ...template }));
          }
          throw err;
        });
    }
  }, [previewMode]);

  const renderPreviewForm = () => {
    if (previewMode && !previewTemplate) {
      return (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      );
    }
    return previewMode && previewTemplate ? (
      <ModalFormPreview
        shouldOpen={previewMode}
        handlePreviewModeClose={handlePreviewModeClose}
      >
        <FormPreview template={previewTemplate} />
      </ModalFormPreview>
    ) : null;
  };

  return (
    <Container w="100%" h="100%" maxW="100%" m="2rem auto">
      {renderPreviewForm()}
      {props.currentTemplate && props.currentTemplate.id && (
        <Redirect to="dashboard" />
      )}
      {props.status == "loading" ? (
        <Center h="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
        </Center>
      ) : (
        <>
          {/* header */}
          <Header template={props.currentTemplate} />
          {/* TemplateList */}
          <TemplateList
            onClickUseTemplateHandler={onClickUseTemplateHandler}
            onClickPreviewHandler={onClickPreviewHandler}
            templates={props.templates}
          />
          <CustomModal
            showModal={showModal}
            handleOnClose={handleOnClose}
            handleFormSubmit={handleFormSubmit}
          />
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    templates: state.templates.list,
    status: state.templates.status,
    currentTemplate: state.templates.currentTemplate,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchCreateTemplate: bindActionCreators(createTemplate, dispatch),
    dispatchGetTemplates: bindActionCreators(getTemplates, dispatch),
    dispatchGetTemplate: bindActionCreators(getTemplate, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseTemplatePage);
